import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create((colors, rt) => ({
  bottomSheet: {
    backgroundColor: colors.backgroundL0,
    paddingHorizontal: theme.spacing[5],
    paddingBottom: theme.spacing[7] + rt.insets.bottom,
    gap: theme.spacing[4],
  },
  inputContainer: {
    marginBottom: theme.spacing[8],
  },
  inputLabel: {
    marginBottom: theme.spacing[3],
  },
  input: {
    height: 50,
    borderRadius: theme.borderRadius.m,
    borderWidth: 1.5,
    borderColor: colors.borderPrimary,
    backgroundColor: colors.backgroundL0,
  },
}));
